module.exports = __webpack_public_path__ + "static/img/patho-erosion-low-BBs4bIzG.569fda4c.png";